import { render, staticRenderFns } from "./Inspiration.vue?vue&type=template&id=0efa3b10&scoped=true&"
import script from "./Inspiration.vue?vue&type=script&lang=js&"
export * from "./Inspiration.vue?vue&type=script&lang=js&"
import style0 from "./Inspiration.vue?vue&type=style&index=0&id=0efa3b10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0efa3b10",
  null
  
)

export default component.exports